import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { formatDate } from '../../library/utils';
import styles from './acitivityLogs.module.scss';
const { Panel } = Collapse;

const ActivityLogs = ({ logs }) => {
    return (
        <Collapse  expandIconPosition="end" defaultActiveKey={"1"}>
            <Panel header='Activity Logs' key="1">
                <div className={styles.activityLogs}>
                    {logs.map(({ message, date }) => (
                        <div key={date}>
                            <span style={{ fontWeight: '600' }}>{message} <span style={{ float: 'right', fontWeight: '400' }}>{formatDate(date)}</span></span>
                            <br />
                        </div>

                    ))}
                </div>
            </Panel>
        </Collapse >
    )
}

ActivityLogs.propTypes = {
    logs: PropTypes.arrayOf(PropTypes.object).isRequired

}
export default ActivityLogs